import React from 'react';
import { TableDataCase } from '../TableData/TableDataCase';
import { TableData } from '../TableData';
import { UserWithQuizToNoteDef } from '../../../../types/quiz/quiz.def';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { MobileTabLineBox } from '../../../atoms/Texts/MobileTabLineBox';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';

interface QuizRecapUsersTableProps {
  users: UserWithQuizToNoteDef[];
  showStudentResponses: (eleve: UserWithQuizToNoteDef) => void;
  quizId: string;
}

export const QuizRecapUsersTable = ({
  users,
  showStudentResponses,
  quizId
}: QuizRecapUsersTableProps) => {
  const isMobile = useMediaQuery('mobile');
  return isMobile ? (
    <>
      {users?.map((eleve, index) => (
        <FeatureContainer key={index}>
          <MobileTabLineBox
            texts={[
              { text: eleve?.lastname, style: 'bold' },
              { text: eleve?.firstname, style: 'bold' }
            ]}
          />
          <MobileTabLineBox
            title="Note"
            texts={[
              {
                text: eleve.quiztonotes.find(qtn => qtn.quiz === quizId)?.note
                  ? `${
                      eleve.quiztonotes.find(qtn => qtn.quiz === quizId)?.note
                    } / 20`
                  : 'Sans réponse',
                style: 'bold'
              }
            ]}
          />
          <ButtonWithText
            variant="mobileTab"
            onClick={() => showStudentResponses(eleve)}
            icon={'Info'}
            content="Voir les réponses"
          />
        </FeatureContainer>
      ))}
    </>
  ) : (
    <TableData tabLabels={['Nom', 'Prénom', 'Note', 'Voir les réponses']}>
      {users?.map((eleve, index) => (
        <tr key={index}>
          <TableDataCase variant={'data'} data={eleve.lastname} />
          <TableDataCase variant={'data'} data={eleve.firstname} />
          <TableDataCase
            variant={'data'}
            data={
              eleve.quiztonotes.find(qtn => qtn.quiz === quizId)?.note
                ? `${
                    eleve.quiztonotes.find(qtn => qtn.quiz === quizId)?.note
                  } / 20`
                : 'Sans réponse'
            }
          />
          <TableDataCase
            onClick={() => showStudentResponses(eleve)}
            variant={'icon'}
            icon={'Info'}
          />
        </tr>
      ))}
    </TableData>
  );
};
